import React from "react";
import { APPENDIX_CAP } from "../../lib/appendix";

const GAP_LABEL = { entra_p1: "Entra ID P1", entra_p2: "Entra ID P2", intune_p1: "Intune Plan 1" };

const status = (u) => {
  const out = [];
  if (u.mfa_registered === false) out.push("no MFA");
  (u.admin_roles || []).forEach((r) => out.push(r.replace(" Administrator", " admin")));
  if ((u.admin_roles || []).length) out.push(u.entra === "p2" ? "Entra P2" : u.entra === "p1" ? "Entra P1 only" : "no Entra P1/P2");
  if (u.legacy_signins > 0) out.push(`${u.legacy_signins} legacy sign-in${u.legacy_signins === 1 ? "" : "s"} (${(u.legacy_apps || []).join(", ")})`);
  if (!u.enabled) out.push("disabled");
  if (u.guest) out.push("guest");
  return out.join(" · ") || "—";
};

/** Appendix sections for the proposal PDF: one compact table per affected-user list. */
export default function ProposalAppendix({ lists }) {
  if (!lists?.length) return null;
  return (
    <div className="prop-appendix" data-testid="proposal-appendix">
      <h2 className="prop-h2">Appendix - affected users</h2>
      <p className="prop-note">Users behind each proposed move and finding, as of the tenant scan this proposal is based on. Lists longer than {APPENDIX_CAP} rows are truncated - export the full list as CSV from the License gaps / Security drill-downs.</p>
      {lists.map((l, i) => (
        <section key={l.id} className="prop-list" data-testid={`appendix-${l.id}`}>
          <h3>
            A{i + 1}. {l.title} <span className="mono">{l.total.toLocaleString()} user{l.total === 1 ? "" : "s"}</span>
          </h3>
          {l.description && <p className="prop-list-desc">{l.description}</p>}
          <table className="quote-table prop-table appendix-table">
            <thead>
              <tr>
                <th>User</th>
                <th>Department</th>
                <th>Licenses</th>
                <th>Missing</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {l.users.map((u) => (
                <tr key={u.graph_id}>
                  <td>
                    <span className="share-part">{u.display_name}</span>
                    <span className="appendix-upn">{u.upn}</span>
                  </td>
                  <td>{u.department || "—"}</td>
                  <td>{u.licenses.join(", ") || "none"}</td>
                  <td>{(u.gap_missing || []).map((m) => GAP_LABEL[m] || m).join(", ") || "—"}</td>
                  <td>{status(u)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {l.total > l.users.length && <p className="prop-note">+{(l.total - l.users.length).toLocaleString()} more - see the CSV export.</p>}
        </section>
      ))}
    </div>
  );
}
